import { createTelephoneDialogSave } from "#/admin/legacy/page-builder/telephone-dialog-save.js";
import { createSnippetSelect, snippetChoice, snippetParams } from "#/admin/legacy/page-builder/snippet-dialog.js";
import { telephoneDialogData } from "#/admin/legacy/page-builder/telephone-dialog.js";
import { settleMount } from "#ce/framework/mount-ready";
import { loadSelectItems } from "#/admin/legacy/sp-select/load-select-items.js";

(function (inherit, Event, TelephoneBlot, LinkBlot, SmartBlot) {
  "use strict";

  var Delta = Quill.import("delta");

  var BaseTooltip = function BaseTooltip(quill, blot) {
    this.quill = quill;
    this.blot = blot;

    this.hide();
  };

  BaseTooltip.prototype.save = function save(text, data) {
    var attributes = {};
    attributes[this.blot.blotName] = data;

    this.quill.updateContents(new Delta().retain(this.range.index).delete(this.range.length).insert(text, attributes));
    this.quill.setSelection(this.range.index + text.length, Quill.sources.SILENT);

    this.hide();
  };

  BaseTooltip.prototype.hide = function hide() {
    this.range = this.format = null;
  };

  BaseTooltip.prototype.open = function open(range) {
    this.range = range;
    this.edit();
  };

  BaseTooltip.prototype.remove = function remove() {
    this.quill.formatText(this.range, this.blot.blotName, false, Quill.sources.USER);
    this.quill.setSelection(this.range, Quill.sources.SILENT);
    this.hide();
  };

  BaseTooltip.prototype.embedRemove = function embedRemove() {
    this.quill.setSelection(this.range.index, 0, Quill.sources.SILENT);
    this.quill.updateContents(new Delta().retain(this.range.index).delete(this.range.length));
    this.hide();
  };

  BaseTooltip.prototype.getText = function getText() {
    if (this.range) {
      return this.quill.getText(this.range);
    }

    return false;
  };

  // Telephone Tooltip
  var TelephoneTooltip = function TelephoneTooltip(quill) {
    BaseTooltip.call(this, quill, TelephoneBlot);

    var me = this;
    jQuery(this.quill.container).on("quill:blot:telephone:click", function (event, blot) {
      if (blot) {
        var blotData = blot.formats().telephone;
        me.range = {
          index: blot.offset(me.quill.scroll),
          length: blot.length(),
        };
        me.edit(blotData);
      }
    });
  };

  inherit(TelephoneTooltip, BaseTooltip);

  TelephoneTooltip.prototype.edit = function (blotData) {
    var me = this;
    blotData = blotData || {};
    if (!blotData.number) {
      var selectionText = this.getText();
      blotData.number = selectionText || "";
    }

    var callTrackingInitialized = Sparkle.PageBuilder.CallTrackingManager.initialized;
    var template = Sparkle.HandlebarsTemplates["telephone-dialog"];
    var modal = new Sparkle.PageBuilder.Modal.Deprecated();

    updateModal(blotData.number);

    function updateModal(number, numberData) {
      numberData = numberData || {};

      if (callTrackingInitialized) {
        numberData = _.extend({}, Sparkle.PageBuilder.CallTrackingManager.find(number), numberData);
      } else {
        numberData = _.extend({}, { original_number: number }, numberData);
      }

      var templateData = telephoneDialogData(numberData, {
        callTrackingInitialized: callTrackingInitialized,
        workflowItems: Sparkle.PageBuilder.CallTrackingManager.workflow_items,
      });

      modal.setContent(template(templateData));
      Form.decorate(modal.dialog);
    }

    jQuery(modal.dialog).on("change", "[name=number]", function () {
      var numberInput = modal.dialog.querySelector("[name=number]");
      updateModal(numberInput.value);
    });

    jQuery(modal.dialog).on("change", "[name=tracking]", function () {
      var numberInput = modal.dialog.querySelector("[name=number]");
      var trackingInput = modal.dialog.querySelector("[name=tracking]");

      jQuery.post("/admin/phone_numbers/register.json?number=" + numberInput.value).then(
        function (data) {
          var numberData = {};
          if (callTrackingInitialized) {
            numberData = {
              original_number_id: data.id,
              original_local_number: data.local_number,
              wants_local_number: data.wants_local_number,
              enabled: trackingInput.checked,
            };
          }

          updateModal(data.number, numberData);
        },
        function (response) {
          var errorElement = modal.dialog.querySelector(".error");
          errorElement.innerHTML = response.responseJSON.errors;
        },
      );
    });

    // If we're editing an existing telephone number.
    if (blotData.id) {
      modal.setTitle("Edit Phone Number");
      modal.addSecondaryButton(
        "Remove phone number",
        function () {
          me.embedRemove();
          modal.remove();
        },
        "destroy",
      );
    } else {
      modal.setTitle("Insert Phone Number");
    }

    modal.addPrimaryButton(
      "Done",
      createTelephoneDialogSave({
        dialog: modal.dialog,
        callTrackingInitialized: callTrackingInitialized,
        callTrackingManager: Sparkle.PageBuilder.CallTrackingManager,
        registerNumber: function (number) {
          return jQuery.post("/admin/phone_numbers/register.json?number=" + number);
        },
        save: function (data) {
          me.save(data.number, data);
        },
        remove: function () {
          modal.remove();
        },
      }),
      true,
    );

    modal.show();

    var phoneInput = modal.dialog.querySelector("[name=number]");
    phoneInput.focus();
    phoneInput.setSelectionRange(phoneInput.value.length, phoneInput.value.length);
  };

  TelephoneTooltip.prototype.save = function save(text, data) {
    var attributes = {};
    attributes[this.blot.blotName] = data;

    this.quill.updateContents(new Delta().retain(this.range.index).delete(this.range.length));
    this.quill.insertEmbed(this.range.index, this.blot.blotName, data, Quill.sources.USER);
    this.quill.setSelection(this.range.index + 1, Quill.sources.SILENT);

    this.hide();
  };

  // Link Tooltip
  var LinkTooltip = function LinkTooltip(quill, options) {
    BaseTooltip.call(this, quill, LinkBlot);

    var me = this;
    jQuery(this.quill.container).on("quill:blot:link:click", function (event, blot) {
      if (blot) {
        var blotData = blot.formats().link;
        me.range = {
          index: blot.offset(me.quill.scroll),
          length: blot.length(),
        };
        me.edit(blotData);
      }
    });
  };

  inherit(LinkTooltip, BaseTooltip);

  LinkTooltip.prototype.edit = function edit(blotData) {
    var me = this;

    blotData = blotData || {};
    blotData.title = this.getText() || "";

    var dialog = new Sparkle.PageBuilder.LinkDialog(blotData, function (value) {
      me.save(value.title, {
        url: value.url,
        documentTitle: value.documentTitle,
        style: value.style,
        behaviour: value.behaviour,
        target: value.target,
      });
    });

    if (blotData.url) {
      dialog.addRemoveButton(function () {
        me.remove();
        dialog.modal.remove();
      });
    }
  };

  var SmartTooltip = function SmartTooltip(quill) {
    BaseTooltip.call(this, quill, SmartBlot);

    var me = this;
    jQuery(this.quill.container).on("quill:blot:smart:click", function (event, blot) {
      if (blot) {
        var blotData = blot.formats().snippet;
        me.range = {
          index: blot.offset(me.quill.scroll),
          length: blot.length(),
        };
        me.edit(blotData);
      }
    });
  };

  inherit(SmartTooltip, BaseTooltip);

  SmartTooltip.prototype.edit = function (blotData) {
    var me = this;
    blotData = blotData || {};

    var modal = new Sparkle.PageBuilder.Modal.Deprecated();
    const snippetSelect = createSnippetSelect();

    if (blotData.type && blotData.type.length > 0) {
      modal.setTitle("Edit Snippet");
    } else {
      modal.setTitle("Insert Snippet");
    }

    modal.setContent(Sparkle.HandlebarsTemplates["snippet-dialog"]());
    modal.dialog.querySelector(".replacement-component-select").append(snippetSelect);

    const choicesReady = loadSelectItems(snippetSelect, "/admin/snippets.json?api=quantum", {
      selected: blotData.type,
      includeBlank: true,
    }).then(function initializeSnippetChoices(payload) {
      if (!payload) {
        return;
      }

      if (blotData.type && blotData.params) {
        var template = _.find(payload.snippets, function (choice) {
          return choice.value === blotData.type;
        });

        if (template && template.input_params) {
          var storedParams = JSON.parse(blotData.params);
          var params = {};
          jQuery.each(template.input_params, function (key, data) {
            params[key] = jQuery.extend({}, data, { value: storedParams[key] });
          });

          jQuery(modal.dialog)
            .find(".snippet-fields")
            .html(Sparkle.HandlebarsTemplates["snippet-dialog-fields"]({ params: params }));
          Form.decorate(modal.dialog);
        }
      }

      function updateSnippet() {
        const choice = snippetChoice(payload.snippets, snippetSelect.value);

        if (!choice) {
          snippetSelect.value = blotData.type || "";
          return;
        }

        blotData.type = choice.value;
        blotData.placeholder = choice.data.placeholder;

        const params = snippetParams(choice);

        modal.dialog.querySelector(".snippet-fields").innerHTML = Sparkle.HandlebarsTemplates["snippet-dialog-fields"]({
          params: params,
        });
        Form.decorate(modal.dialog);
      }

      snippetSelect.addEventListener("change", updateSnippet);

      return true;
    });

    modal.addSecondaryButton(
      "Remove Snippet",
      function () {
        me.embedRemove();
        modal.remove();
      },
      "destroy",
    );

    modal.addPrimaryButton(
      "Done",
      async function saveSnippet() {
        if (!(await choicesReady)) {
          return;
        }

        const fields = modal.dialog.querySelector(".snippet-fields");
        const controls = Array.from(fields.querySelectorAll("sp-select"));
        const mounted = await Promise.all(controls.map(settleMount));

        if (mounted.some((control) => !control)) {
          return;
        }

        const params = Object.fromEntries(new FormData(fields));

        if (params.label) {
          blotData.placeholder = params.label;
        }
        blotData.params = JSON.stringify(params);

        me.save(blotData.placeholder, blotData);
        modal.remove();
      },
      true,
    );

    modal.show();
  };

  SmartTooltip.prototype.save = function save(text, data) {
    var attributes = {};
    attributes[this.blot.blotName] = data;

    this.quill.updateContents(new Delta().retain(this.range.index).delete(this.range.length));
    this.quill.insertEmbed(this.range.index, this.blot.blotName, data, Quill.sources.USER);
    this.quill.setSelection(this.range.index + 1, Quill.sources.SILENT);

    this.hide();
  };

  // exports
  Sparkle.PageBuilder.Wysiwyg = _.extend(
    {
      Tooltips: {
        LinkTooltip: LinkTooltip,
        TelephoneTooltip: TelephoneTooltip,
        SmartTooltip: SmartTooltip,
      },
    },
    Sparkle.PageBuilder.Wysiwyg,
  );
})(
  Sparkle.PageBuilder.Helpers.inherit,
  Sparkle.PageBuilder.Helpers.Event,
  Sparkle.PageBuilder.Wysiwyg.Blots.TelephoneBlot,
  Sparkle.PageBuilder.Wysiwyg.Blots.LinkBlot,
  Sparkle.PageBuilder.Wysiwyg.Blots.SmartBlot,
);
